import { clientsAPI } from 'api/clientsAPI'
import { useQuery } from '@tanstack/react-query'

export type UserPropertyDefinition = {
  id: number
  clientId: number
  title: string
  userPropertyType: 'FreeFormat' | 'Array'
  isMandatory?: boolean
  values?: string[]
}

export default function useUserProperties(clientId?: number) {
  const query = useQuery({
    queryKey: ['fetchUserProperties', clientId],
    queryFn: () => clientsAPI.getUserProperties(clientId!),
    enabled: Boolean(clientId),
    keepPreviousData: false,
  })

  const userProperties: UserPropertyDefinition[] =
    query.data?.data?.value ?? []

  return {
    userProperties,
    ...query,
  }
}
